module.exports = {
          srcSet: __webpack_public_path__ + "76c008fa67a21543135f1766e38afc18-65.png"+" 65w",
          images:[ {path: __webpack_public_path__ + "76c008fa67a21543135f1766e38afc18-65.png",width: 65,height: 65}],
          src: __webpack_public_path__ + "76c008fa67a21543135f1766e38afc18-65.png",
          toString:function(){return __webpack_public_path__ + "76c008fa67a21543135f1766e38afc18-65.png"},
          
          width: 65,
          height: 65
        }